if (typeof boostPFSThemeConfig != 'undefined') {

  // Override Settings
  var boostPFSFilterConfig = {
    general: {
      limit: boostPFSConfig.custom.products_per_page,
      /* Optional */
      loadProductFirst: false,
    },
    selector: {
      avoidStickyHeader: '#shopify-section-announcement-bar, #shopify-section-header,.site-header--opening, .js-navigation, .js-mobile-header-wrapper, .mobile-nav-bar-wrapper, mobile_nav-fixed--true, .site-header--sticky, .site-header-wrapper .action-bar-wrapper, .Header__Wrapper',
    }
  };

  (function () {
    BoostPFS.inject(this);
    /************************** BUILD PRODUCT LIST **************************/
    // Build Product Grid Item
    ProductGridItem.prototype.compileTemplate = function (data, index) {
      if (!data) data = this.data;
      if (!index) index = this.index;
      var soldOut = !data.available,
        onSale = data.compare_at_price_min > data.price_min,
        priceVaries = data.price_min != data.price_max,
        images = data.images_info;
      if (images.length == 0) {
        images.push({
          src: boostPFSConfig.general.no_image_url,
          id: data.id,
          width: 480,
          height: 480
        });
      }
      // Get First Variant (selected_or_first_available_variant)
      var firstVariant = data['variants'][0];
      if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
        var paramVariant = data.variants.filter(function (e) { return e.id == Utils.getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
      } else {
        for (var i = 0; i < data['variants'].length; i++) {
          if (data['variants'][i].available) {
            firstVariant = data['variants'][i];
            break;
          }
        }
      }
      // Get Template
      var itemHtml = boostPFSTemplate.productGridItemHtml;

      //Add class
      itemHtml = itemHtml.replace(/{{mobile_items_per_row}}/g, boostPFSConfig.custom.mobile_items_per_row);
      itemHtml = itemHtml.replace(/{{tablet_items_per_row}}/g, boostPFSConfig.custom.tablet_items_per_row);
      itemHtml = itemHtml.replace(/{{desktop_items_per_row}}/g, boostPFSConfig.custom.desktop_items_per_row);
      itemHtml = itemHtml.replace(/{{horizontal_class}}/g, boostPFSConfig.custom.horizontal_class);
      itemHtml = itemHtml.replace(/{{filter_position_class}}/g, boostPFSConfig.custom.filter_position);


      var has_alternate_image = false;
      if (images.length > 1 &&
        boostPFSConfig.custom.hasOwnProperty('product_show_secondary_image') &&
        boostPFSConfig.custom.product_show_secondary_image == true) {
        has_alternate_image = true;
      }
      itemHtml = itemHtml.replace(/{{has_alternate_image_class}}/g, has_alternate_image ? "ProductItem__ImageWrapper--withAlternateImage" : "");

      var use_natural_size = false;
      if (boostPFSConfig.custom.hasOwnProperty('product_image_size') &&
        boostPFSConfig.custom.product_image_size == 'natural' || boostPFSThemeConfig.custom.use_horizontal) {
        use_natural_size = true;
      }
      itemHtml = itemHtml.replace(/{{use_natural_size_class}}/g, use_natural_size ? "withFallback" : boostPFSConfig.custom.product_image_size);
      var media_aspect_ratio = images[0].width / images[0].height;
      var max_width = images[0].width;
      if (boostPFSThemeConfig.custom.use_horizontal) max_width = 125;
      itemHtml = itemHtml.replace(/{{padding_bottom}}/g, use_natural_size ? 'padding-bottom: ' + (100 / media_aspect_ratio) + '%;' : '');
      itemHtml = itemHtml.replace(/{{media_aspect_ratio}}/g, media_aspect_ratio);
      itemHtml = itemHtml.replace(/{{max_width}}/g, max_width);

      var sizes0 = '200,400,600,700,800,900,1000,1200';
      var image_url = Utils.optimizeImage(images[0]['src'], '{width}x');
      itemHtml = itemHtml.replace(/{{image_url}}/g, image_url);
      itemHtml = itemHtml.replace(/{{supported_sizes}}/g, imageSize(sizes0, images[0]));
      itemHtml = itemHtml.replace(/{{featured_media_id}}/g, images[0].id);
      var featured_media_url = Utils.optimizeImage(images[0]['src'], '600x');
      itemHtml = itemHtml.replace(/{{featured_media_url}}/g, featured_media_url);




      var alternate_image = '';


      if (has_alternate_image && images.length > 1) {
        var sizes1 = '200,300,400,600,800,900,1000,1200';
        var thumbUrl = Utils.optimizeImage(images[1]['src'], '{width}x');
        alternate_image += '<img class="ProductItem__Image ProductItem__Image--alternate Image--lazyLoad Image--fadeIn" data-src="' + thumbUrl + '" data-widths="[' + imageSize(sizes1, images[1]) + ']"  data-sizes="auto" alt="' + data.title + '" data-image-id="' + images[1].id + '">';
      }
      itemHtml = itemHtml.replace(/{{alternate_image}}/g, alternate_image);

      var product_media1_url = featured_media_url;
      if (images.length > 1) {
        product_media1_url = Utils.optimizeImage(images[1]['src'], '600x');
      }
      itemHtml = itemHtml.replace(/{{product_media1_url}}/g, product_media1_url);



      // Add Label
      itemHtml = itemHtml.replace(/{{product_labels}}/g, buildLabels(data));

      // Add main attribute (Always put at the end of this function)
      itemHtml = itemHtml.replace(/{{product_info}}/g, buildInfo(data, index));

      var view_product = boostPFSConfig.custom.use_horizontal ? '<a href="{{itemUrl}}" class="ProductItem__ViewButton Button Button--secondary hidden-pocket">' + boostPFSConfig.label.view_product + '</a>' : '';
      itemHtml = itemHtml.replace(/{{view_product}}/g, view_product);

      // Add Reviews
      if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
        itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
      }
      itemHtml = itemHtml.replace(/{{buildClassHiz}}/g, buildClassHiz());
      itemHtml = itemHtml.replace(/{{buildClass}}/g, buildClass());
      itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

      return itemHtml;
    };

    /************************** END BUILD PRODUCT LIST **************************/
    /************************** BUILD PRODUCT ITEM ELEMENTS **************************/
    function buildClass() {
      return boostPFSConfig.custom.filter_position == 'drawer' ? 'lap-and-up' : 'desk';
    }

    function buildClassHiz() {
      return boostPFSConfig.custom.use_horizontal ? 'ProductItem--horizontal' : '';
    }

    function imageSize(sizes, image) {
      if (image) {
        var desired_sizes = sizes.split(',');
        var supported_sizes = '';
        for (var k = 0; k < desired_sizes.length; k++) {
          var size = desired_sizes[k];
          var size_as_int = size * 1;
          if (image.width < size_as_int) { break; }
          supported_sizes = supported_sizes + size + ',';
        }

        if (supported_sizes == '') supported_sizes = image.width;

        if (!jQ.isNumeric(supported_sizes)) {
          supported_sizes = supported_sizes.split(',').join(',');
          supported_sizes = supported_sizes.substring(0, supported_sizes.lastIndexOf(','));
        }
        return supported_sizes;
      } else {
        return '';
      }
    }

    function buildPrice(data) {
      var html = '';
      var show_price_on_hover = boostPFSConfig.custom.product_show_price_on_hover;
      var classPriceHover = show_price_on_hover ? 'ProductItem__PriceList--showOnHover' : '';
      html += '<div class="ProductItem__PriceList ' + classPriceHover + ' Heading">';
      if (data.compare_at_price_min > data.price_min) {
        html += '<span class="ProductItem__Price Price Price--highlight Text--subdued" data-money-convertible>' + Utils.formatMoney(data.price_min) + '</span> ';
        html += '<span class="ProductItem__Price Price Price--compareAt Text--subdued" data-money-convertible>' + Utils.formatMoney(data.compare_at_price_min) + '</span>';
      } else {
        if (data.price_min != data.price_max) {
          html += '<span class="ProductItem__Price Price Text--subdued">' + boostPFSConfig.label.from_price_html.replace(/{{min_price}}/g, Utils.formatMoney(data.price_min)) + '</span>';
        } else {
          html += '<span class="ProductItem__Price Price Text--subdued" data-money-convertible>' + Utils.formatMoney(data.price_min) + '</span>';
        }
      }
      html += '</div>';
      return html;
    }

    function buildAddToCart(data) {
      let ctaBtns = '';
      if (data.variants.length == 1 && data.variants[0].available == false) { 
        ctaBtns += '<div data-osf-type="oos" class="Button osf--oos Button--primary Button--full" data-osf-id="' + data.id + '">Notify Me</div>';
      } else {
        ctaBtns += '<button data-use-primary-button="true" class="quick--view Button Button--primary Button--full"><span>ADD TO CART</span></button>';
      }
      var html = '';
      html += '<div class="ProductItem__addToCart">';
      html +=
      `<form accept-charset="UTF-8" class="ProductForm" enctype="multipart/form-data" action="/cart/add" id="product_form_${data.id}" method="post" >
      <input type="hidden" name="form_type" value="product">
      <input type="hidden" name="utf8" value="✓">
      <input type="hidden" name="id" value="${data.variants[0].id}">
      <input type="hidden" name="quantity" value="1">`
      html += ctaBtns;
      html += '</form>';
      //   `<form accept-charset="UTF-8" class="ProductForm" enctype="multipart/form-data" action="/cart/add" id="product_form_${data.id}" method="post" >
      // <input type="hidden" name="form_type" value="product">
      // <input type="hidden" name="utf8" value="✓">
      // <input type="hidden" name="id" value="${data.variants[0].id}">
      // <input type="hidden" name="quantity" value="1">
      // <button data-use-primary-button="true" class="quick--view Button Button--primary Button--full"><span>QUICK VIEW</span></button>
      // <button type="submit" data-use-primary-button="true" data-action="add-to-cart" class="atc_prod Button Button--primary Button--full"><span>ADD TO CART</span></button>
      // </form>`
      html += '</div>';
      return html;
    }
    function buildQuickViewModal(data) {
      let featured_image_src = data.images_info[0].src;
      let featured_image_alt = data.images_info[0].alt;
      let featured_image_id = data.images_info[0].id;
      let moneyFormat = boostPFSConfig.shop.money_format;
      let windowObjDiscountPercentages = window.taggedDiscounts ? window.taggedDiscounts.productsWithDiscountPercentage : '';
      let productDiscountPercentage = windowObjDiscountPercentages[data.id] ? windowObjDiscountPercentages[data.id] : 0 ;
      let discount = (data.variants[0].price * 100) * productDiscountPercentage;
      
      let originalPrice = Utils.formatMoney(data.variants[0].price )
      let taggedDiscountPrice = Utils.formatMoney((data.variants[0].price ) - discount)
      let compareAtPrice = Utils.formatMoney((data.variants[0].compare_at_price ) - discount)
      let priceHtml = '';
      let firstAvailable = 'first-available';
      let hasOOSVariant = false;
      // check all variants in data to see if any are unavailable
      for (let i = 0; i < data.variants.length; i++) {
        if (!data.variants[i].available) {
          hasOOSVariant = true;
          break;
        }
      }
      if (!data.variants[0].available) firstAvailable = 'first-unavailable'
      let notifyInStockBtn =`<div data-osf-type="oos" class="Button osf--oos Button--primary Button--full" data-osf-id='${data.id}'>Notify Me</div>`;
      if (compareAtPrice != null && compareAtPrice > originalPrice) {
        priceHtml = `<span class="product--price__tagged">${originalPrice}</span><span class="product--price__original discounted">${compareAtPrice}</span>`
      }
      if (originalPrice != taggedDiscountPrice) {
        if (compareAtPrice != null && compareAtPrice > originalPrice) {
          originalPrice = compareAtPrice;
        }
        priceHtml = `<span class="product--price__tagged">${taggedDiscountPrice}</span><span class="product--price__original discounted">${originalPrice}</span>`
      } else if (compareAtPrice == '£0.00') {
        priceHtml = `<span class="product--price__original">${originalPrice}</span>`
      }
      var html = '';
      html += '<div class="ProductItem__quick--view-modal">';

      html += '<div class="ProductItem__quick--view-modal--inner">';

      html += '<button class="close--modal btn" type="button" aria-label="Close" data-close-modal="true">';
      html += '<img src="https://cdn.shopify.com/s/files/1/0587/3257/6962/files/close_1.png?v=1670514437" alt="Close" class="Button__icon">';
      html += '</button>';
      // product image 
      html += '<div class="quick--view_featured-image quick--view-half">';
      html += `<img src="${featured_image_src}" alt="${featured_image_alt}">`;
      html += '</div>';
      // product info
      html += '<div class="quick--view_product-info quick--view-half">';
      html += '<div class="product--vendor">';
      html += `<p>${data.vendor}</p>`;
      html += '</div>';
      html += '<div class="product--title">';
      html += `<p>${data.title}</p>`;
      html += '</div>';
      html += '<div class="product--price">'; 
      html += `${priceHtml}`;
      html += '</div>';
    //   html += '<div class="product--share_shipping">';
    //   html += `<div class="ProductMeta__ShareButtons hidden-pocket" {{ block.shopify_attributes }}>
    //   <span class="ProductMeta__ShareTitle Heading Text--subdued u-h7">SHARE</span>
    //   <div class="ProductMeta__ShareList Text--subdued">
    //     <a class="ProductMeta__ShareItem" href="https://www.facebook.com/sharer.php?u=${window.location.host}/products/${data.handle}" target="_blank" rel="noopener" aria-label="Facebook">
    //     <svg viewBox="0 0 9 17">
    //     <path d="M5.842 17V9.246h2.653l.398-3.023h-3.05v-1.93c0-.874.246-1.47 1.526-1.47H9V.118C8.718.082 7.75 0 6.623 0 4.27 0 2.66 1.408 2.66 3.994v2.23H0v3.022h2.66V17h3.182z"></path>
    //     </svg>
    //     </a>
    //     <a class="ProductMeta__ShareItem" href="https://twitter.com/share?text=${data.title}&url=${window.location.host}" target="_blank" rel="noopener" aria-label="Twitter"><svg role="presentation" viewBox="0 0 32 26">
    //     <path d="M32 3.077c-1.1748.525-2.4433.8748-3.768 1.031 1.356-.8123 2.3932-2.0995 2.887-3.6305-1.2686.7498-2.6746 1.2997-4.168 1.5934C25.751.796 24.045.0025 22.158.0025c-3.6242 0-6.561 2.937-6.561 6.5612 0 .5124.0562 1.0123.1686 1.4935C10.3104 7.7822 5.474 5.1702 2.237 1.196c-.5624.9687-.8873 2.0997-.8873 3.2994 0 2.2746 1.156 4.2867 2.9182 5.4615-1.075-.0314-2.0872-.3313-2.9745-.8187v.0812c0 3.1806 2.262 5.8363 5.2677 6.4362-.55.15-1.131.2312-1.731.2312-.4248 0-.831-.0438-1.2372-.1188.8374 2.6057 3.262 4.5054 6.13 4.5616-2.2495 1.7622-5.074 2.812-8.1546 2.812-.531 0-1.0498-.0313-1.5684-.0938 2.912 1.8684 6.3613 2.9494 10.0668 2.9494 12.0726 0 18.6776-10.0043 18.6776-18.6776 0-.2874-.0063-.5686-.0188-.8498C30.0066 5.5514 31.119 4.3954 32 3.077z"></path>
    //   </svg>
    //   </a>
    //     <a class="ProductMeta__ShareItem" href="https://pinterest.com/pin/create/button/?url=${window.location.host}&media=${featured_image_src}&description=${data.body_html}" target="_blank" rel="noopener" aria-label="Pinterest"><svg role="presentation" viewBox="0 0 32 32">
    //     <path d="M16 0q3.25 0 6.208 1.271t5.104 3.417 3.417 5.104T32 16q0 4.333-2.146 8.021t-5.833 5.833T16 32q-2.375 0-4.542-.625 1.208-1.958 1.625-3.458l1.125-4.375q.417.792 1.542 1.396t2.375.604q2.5 0 4.479-1.438t3.063-3.937 1.083-5.625q0-3.708-2.854-6.437t-7.271-2.729q-2.708 0-4.958.917T8.042 8.689t-2.104 3.208-.729 3.479q0 2.167.812 3.792t2.438 2.292q.292.125.5.021t.292-.396q.292-1.042.333-1.292.167-.458-.208-.875-1.083-1.208-1.083-3.125 0-3.167 2.188-5.437t5.729-2.271q3.125 0 4.875 1.708t1.75 4.458q0 2.292-.625 4.229t-1.792 3.104-2.667 1.167q-1.25 0-2.042-.917t-.5-2.167q.167-.583.438-1.5t.458-1.563.354-1.396.167-1.25q0-1.042-.542-1.708t-1.583-.667q-1.292 0-2.167 1.188t-.875 2.979q0 .667.104 1.292t.229.917l.125.292q-1.708 7.417-2.083 8.708-.333 1.583-.25 3.708-4.292-1.917-6.938-5.875T0 16Q0 9.375 4.687 4.688T15.999.001z"></path>
    //   </svg>
    //   </a>
    //   </div>
    // </div>
    // <a href="/policies/shipping-policy" class="Heading Text--subdued u-h7">SHIPPING INFO</a></div>`;


      html += '<div class="ProductForm__Content">';
      html += '<form action="/cart/add" method="post" enctype="multipart/form-data" class="ProductForm ProductForm--quickView">';

      
      // variants
      html += '<div class="quick--view__productOptions">'
      html += buildVariantOptions(data);
      html += '</div>';

      // quantity
      html += '<div class="quick--view__productQuantity">';
      html += buildQuantity(data);
      html += '</div>';

      // add to cart button
      html += '<div class="quick--view__productAddToCart' + ' oos--' + firstAvailable + '"' +'>';
      html += '<button type="submit" class="Button atc_prod Button--primary Button--large Button--fullWidth">Add to Cart</button>';
      if (hasOOSVariant) html += notifyInStockBtn;
      html += '</div>';

      html += '<div id="stockReminderForm"></div>'

      html += '</form>';

      html += `<a class="quick--view__product-details Heading Text--subdued u-h7" href='/products/${data.handle}'><span>SEE FULL DETAILS</span><span>
                    <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <rect x="0.5" width="14" height="14" fill="url(#pattern${data.id})"/>
              <defs>
              <pattern id="pattern${data.id}" patternContentUnits="objectBoundingBox" width="1" height="1">
              <use xlink:href="#image0_1972_1115" transform="scale(0.00195312)"/>
              </pattern>
              <image id="image0_1972_1115" width="512" height="512" xlink:href="data:image/png;base64,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"/>
              </defs>
              </svg></span></a>
              `;
      html += '</div>'

      html += '</div>';


      html += '</div>';
      html += '</div>';

      return html;
    }

    function buildQuantity(data) { 
      let quantityHTML = '';
      let classNames = 'ProductForm__QuantitySelector';
      if (data.variants[0].title == 'Default Title') {
        classNames = 'ProductForm__QuantitySelector no-variant';
      }
      quantityHTML += `
      <div class="${classNames}">
      <div class="QuantitySelector QuantitySelector--large">
        <button type="button" class="QuantitySelector__Button Link Link--secondary" data-action="decrease-quantity"><svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
<rect x="13.0762" y="10.955" width="13.0756" height="10.193" transform="rotate(-180 13.0762 10.955)" fill="url(#pattern--${data.id}-minus)"/>
<defs>
<pattern id="pattern--${data.id}-minus" patternContentUnits="objectBoundingBox" width="1" height="1">
<use xlink:href="#image0_1972_1107" transform="translate(0 -0.141399) scale(0.00195312 0.00250547)"/>
</pattern>
<image id="image0_1972_1107" width="512" height="512" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgAAAAIACAYAAAD0eNT6AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAOxAAADsQBlSsOGwAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAASsSURBVHic7dZLjUJRFETRQwcPCOnWgw70oAdcMMEFBpi8Gz6d7LXmldRwzwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwCfsFjaHmTm++ggAsOw8M/ctg5UA+J2Zy8IOAHiPv5m5bhn8vOkIAPCPCQAACBIAABAkAAAgSAAAQJAAAIAgAQAAQQIAAIIEAAAECQAACBIAABAkAAAgSAAAQJAAAIAgAQAAQQIAAIIEAAAECQAACBIAABAkAAAgSAAAQJAAAIAgAQAAQQIAAIIEAAAECQAACBIAABAkAAAgSAAAQJAAAIAgAQAAQQIAAIIEAAAECQAACBIAABAkAAAgSAAAQJAAAIAgAQAAQQIAAIIEAAAE7Rc2t5k5vfoIALDs9u0DAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADw3AMnNAaZlEA3VgAAAABJRU5ErkJggg=="/>
</defs>
</svg>
</button>
        <input type="text" class="QuantitySelector__CurrentQuantity" pattern="[0-9]*" name="quantity" value="1" min="1" aria-label="quantity selector">
        <button type="button" class="QuantitySelector__Button Link Link--secondary" data-action="increase-quantity"><svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <rect x="0.564453" y="0.733505" width="17.4341" height="13.5907" fill="url(#pattern--${data.id}-add)"/>
        <defs>
        <pattern id="pattern--${data.id}-add" patternContentUnits="objectBoundingBox" width="1" height="1">
        <use xlink:href="#image0_1972_1106" transform="translate(0 -0.141399) scale(0.00195312 0.00250547)"/>
        </pattern>
        <image id="image0_1972_1106" width="512" height="512" xlink:href="data:image/png;base64,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"/>
        </defs>
        </svg>
        </button>
      </div>
    </div>`;
      return quantityHTML;
    }

    function buildVariantOptions(data) {
      let options = data.variants;
      let optionsHTML = '';
      let optionsImagesHTML = '';
      let optionsImagesContainerHTML = '';
      let optionsSelectHTML = '';
      let mainSelectHTML = '';

      // coloured radio buttons
      if (options[0].title != "Default Title" && data.options[0] != "size") {
        options.forEach(function (option) {
          // check if the option is already in the html by splitting the option name and checking the first value - to ensure no duplicates
          if (optionsImagesHTML.indexOf(option.title.split(' / ')[0]) == -1) {
            optionsImagesHTML +=
              `<div>
            <input type="radio" id="${option.id}" name="${data.id}" value="${option.id}">
            <label class="quick--view__label" style="background-image:url('${option.image}')" for="${option.id}"><span>${option.title}</span></label>
          </div>`;
          }
        });
      }

      // product has variants as the first variant isn't the default title
      if (options[0].title != "Default Title") {
      // get product options (could be one or two)
        let productOptions = data.options;
      // create an array that will hold the selects
        let selects = [];
      // iterate over product options
        productOptions.forEach(function (option, index) {
          // iterate over product variants
          options.forEach(function (variant) {
            // add every product to the main select html element
            mainSelectHTML += `<option value="${variant.id}" data-availability="${variant.available}">${variant.title}</option>`;
            // create html option
            // check if the option is already in the html by splitting the option name and checking the first value - to ensure no duplicates
            if (optionsHTML.indexOf(variant[`option${index + 1}`].split(' / ')[0]) == -1) {
              // work out prices based on discounts (WHOLESALE CLUB DISCOUNTS)
              // Created a window object that holds the product id and the discount percentage in Theme.liquid
              // This is then used to calculate the discounted price
              // if no discount is set (user not logged in) then the discount is set to 0 which then returns the original price
               let windowObjDiscountPercentages = window.taggedDiscounts ? window.taggedDiscounts.productsWithDiscountPercentage : '';
              let productDiscountPercentage = windowObjDiscountPercentages[data.id] ? windowObjDiscountPercentages[data.id] : 0 ;
              let discount = (variant.price * 100) * productDiscountPercentage;
              let originalPrice = Utils.formatMoney(variant.price * 100)
              let taggedDiscountPrice = Utils.formatMoney((variant.price * 100) - discount)
              let compareAtPrice = Utils.formatMoney((variant.compare_at_price * 100) - discount)
              optionsHTML += `<option data-title="${variant.title}" data-price="${originalPrice}" data-tagged-discount-price="${taggedDiscountPrice}" data-compare-at-price="${compareAtPrice}" value="${variant.id}">${variant[`option${index + 1}`]}</option>`;
            }

          });
          // create select html
          optionsSelectHTML += `<select class="${option}_select">${optionsHTML}</select>`;
          // reset options html
          optionsHTML = '';
          // add the select to the selects array
          selects.push(optionsSelectHTML);
          // reset options select html
          optionsSelectHTML = '';
        });

        // add class to the select with the class name of size_select only if there is one select with the class name of aize_select (size_select)
        if (selects.length == 1 && selects[0].indexOf('size_select') != -1) selects[0] = selects[0].replace('size_select', 'size_select no-colours');


        // create a container for the radio buttons if there are any options
        if (optionsImagesHTML != '') optionsImagesContainerHTML = `<div class="quick--view__radioOptionsContainer">${optionsImagesHTML}</div>`;
        // create a main hidden select with all the options
        let mainSelect = `<select class="quick--view__select-main--ID" name="id" style="display:none">${mainSelectHTML}</select>`;
        
        return optionsImagesContainerHTML + selects.join('') + mainSelect;
      } else {
        return `<input type="hidden" name="id" value="${data.variants[0].id}">`;
      }
    }


    function buildLabels(data) {
      var html = '';
      var product_labels = '';
      if (boostPFSConfig.custom.show_labels) {
        product_labels = '';
        var tags = data.tags;
        for (var k = 0; k < tags.length; k++) {
          var tag = tags[k];
          if (tag.indexOf('__label') != -1) {
            product_labels += '<span class="ProductItem__Label Heading Text--subdued">' + tag.split('__label:')[1] + '</span>';
            break;
          }
        }
        if (data.available) {
          if (data.compare_at_price_min > data.price_min)
            product_labels += '<span class="ProductItem__Label Heading Text--subdued">' + boostPFSConfig.label.sale + '</span>';
        } else {
          product_labels += ' <span class="ProductItem__Label Heading Text--subdued">' + boostPFSConfig.label.sold_out + '</span>';
        }

        if (product_labels != '') {
          html += '<div class="ProductItem__LabelList">';
          html += product_labels;
          html += '</div>';
        }
      }
      return html;
    }

    function buildInfo(data, indx) {
      var html = '';
      if (boostPFSConfig.custom.show_product_info) {
        var infoClass = (!boostPFSConfig.custom.use_horizontal) ? 'ProductItem__Info--' + boostPFSConfig.custom.product_info_alignment : '';
        html += '<div class="ProductItem__Info ' + infoClass + ' ">';
        if (boostPFSConfig.custom.show_vendor) {
          html += '<p class="ProductItem__Vendor Heading">' + data.vendor + '</p>'
        }

        html += '<h2 class="ProductItem__Title Heading">';
        html += '<a href="{{itemUrl}}">' + data.title + '</a>';
        html += '</h2>';
        html += '{{itemReviews}}';
        html += buildPrice(data);
        html += buildQuickViewModal(data);
        if (boostPFSConfig.custom.show_color_swatch) {
          html += buildSwatch(data, indx);
        }
        html += '</div>';
        html += buildAddToCart(data);
      }

      return html;
    }

    function buildSwatch(data, indx) {
      var itemSwatchHtml = '';
      if (boostPFSConfig.custom.show_color_swatch) {
        var color_name = boostPFSConfig.custom.section_id + '-' + data.id + '-' + indx;
        data.options_with_values.forEach(function (option, index) {
          var option_name = option.name.toLowerCase();
          if (option_name.indexOf('color') != -1 || option_name.indexOf('colour') != -1 || option_name.indexOf('couleur') != -1) {
            var values = '';
            itemSwatchHtml += '<div class="ProductItem__ColorSwatchList">';
            var i = 0;
            data.variants.forEach(function (variant) {
              var temp = variant.merged_options.filter(function (obj) {
                obj = obj.toLowerCase();
                if (obj.indexOf('color') != -1 || obj.indexOf('colour') != -1 || obj.indexOf('couleur') != -1)
                  return obj;
              });
              temp = temp[0].split(':');

              var value = temp[1].toLowerCase();
              if (values.indexOf(value) == -1) {
                values = values + ',' + value;
                values = values.split(',');
                var size = '200,400,600,700,800,900,1000,1200';
                var supported_sizes = imageSize(size, variant.image);
                var color_image = Utils.optimizeImage(variant.image);
                var name_color = Utils.slugify(value) + '.png';
                var checked = (i == 0) ? 'checked=checked' : '';
                var imageInfo = null;
                var image_aspect_ratio = 1;
                imageInfo = data.images_info.find(function (imageOb) {
                  if (imageOb.src == variant.image) {
                    image_aspect_ratio = imageOb.width / imageOb.height;
                    return imageOb;
                  }
                });
                if (!imageInfo) {
                  if (data.images_info.length > 0) {
                    imageInfo = data.images_info[0];
                  } else {
                    imageInfo = {
                      src: boostPFSConfig.general.no_image_url,
                      id: variant.id,
                      width: 480,
                      height: 480
                    }
                  }

                }
                var dataImg = (imageInfo != null) ? '" data-image-url="' + imageInfo.src + '" data-image-widths="[' + supported_sizes + ']" data-image-aspect-ratio="1" data-image-id="' + imageInfo.id + '"' : '';
                var color_input_id = color_name + "-" + values.length;
                var variant_price = variant.price ? variant.price : 0;
                var variant_compare_at_price = variant.compare_at_price ? variant.compare_at_price : 0;
                var url_color = Utils.getFilePath(Utils.slugify(value), Globals.swatchExtension, Settings.getSettingValue('general.swatchImageVersion'));
                itemSwatchHtml += '<div class="ProductItem__ColorSwatchItem">';
                itemSwatchHtml += '<input class="ColorSwatch__Radio" type="radio" ' + checked + ' name="' + color_name + '" id="' + color_input_id + '" value="' + value + '" data-image-aspect-ratio="' + image_aspect_ratio + '" data-variant-price="' + variant_price + '" data-variant-compare-at-price="' + variant_compare_at_price + '" data-variant-url="' + Utils.buildProductItemUrl(data) + '?variant=' + variant.id + '#Image' + imageInfo.id + '"' + dataImg + '  aria-hidden="true">';
                itemSwatchHtml += '<label class="ColorSwatch ColorSwatch--small" for="' + color_input_id + '" style="background-color: ' + value.replace(' ', '').toLowerCase() + '; background-image: url(' + url_color + ')" title="' + value + '" data-tooltip="' + value + '"></label>';
                itemSwatchHtml += '</div>';
                i++;
              }
            });
            itemSwatchHtml += '</div>';
          }
        });
      }
      return itemSwatchHtml;
    }
    /************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
    /************************** BUILD TOOLBAR **************************/
    // Build Pagination
    ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
      if (!totalProduct) totalProduct = this.totalProduct
      // Get page info
      var currentPage = parseInt(Globals.queryParams.page);
      var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

      if (totalPage > 1) {
        var paginationHtml = boostPFSTemplate.paginateHtml;
        // Build Previous
        var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
        previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
        // Build Next
        var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
        nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
        // Create page items array
        var beforeCurrentPageArr = [];
        for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
          beforeCurrentPageArr.unshift(iBefore);
        }
        if (currentPage - 4 > 0) {
          beforeCurrentPageArr.unshift('...');
        }
        if (currentPage - 4 >= 0) {
          beforeCurrentPageArr.unshift(1);
        }
        beforeCurrentPageArr.push(currentPage);
        var afterCurrentPageArr = [];
        for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
          afterCurrentPageArr.push(iAfter);
        }
        if (currentPage + 3 < totalPage) {
          afterCurrentPageArr.push('...');
        }
        if (currentPage + 3 <= totalPage) {
          afterCurrentPageArr.push(totalPage);
        }
        // Build page items
        var pageItemsHtml = '';
        var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
        for (var iPage = 0; iPage < pageArr.length; iPage++) {
          if (pageArr[iPage] == '...') {
            pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
          } else {
            pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
          }
          pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
          pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
        }
        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
        return paginationHtml;
      }

      return '';
    };

    // Build Sorting
    ProductSorting.prototype.compileTemplate = function () {
      var html = '';
      if (boostPFSConfig.custom.show_sorting && boostPFSTemplate.hasOwnProperty('sortingHtml')) {
        var sortingArr = Utils.getSortingList();
        if (sortingArr) {
          // Build content
          var sortingItemsHtml = '';
          for (var k in sortingArr) {
            var classActive = (Globals.queryParams.sort == k) ? 'is-selected' : '';
            sortingItemsHtml += '<button class="Popover__Value ' + classActive + ' Heading Link Link--primary u-h6" data-value="' + k + '">' + sortingArr[k] + '</button>';
          }
          html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
        }
      }
      return html;
    };

    // Build Sorting event
    ProductSorting.prototype.bindEvents = function () {
      var topSortingSelector = jQ(Selector.topSorting);
      topSortingSelector.find('.Popover__Value').click(function (e) {
        FilterApi.setParam('sort', jQ(this).data('value'));
        FilterApi.setParam('page', 1);
        FilterApi.applyFilter('sort');
        jQ('.CollectionToolbar__Item--sort').trigger('click');
      });
    }
    /************************** END BUILD TOOLBAR **************************/

    // Add additional feature for product list, used commonly in customizing product list
    ProductList.prototype.afterRender = function (data, eventType) {
      if (!data) data = this.data;
      if (!eventType) eventType = this.eventType;
      // EVENT HANDLERS //
      window.ORDERSIFY_BIS.collection_products = data;

      setTimeout(() => {
        window.ORDERSIFY_BIS.addFlexibleOOSButtons();
      }, 500);

      // quick-view event handler on collection items
      let addQuickViewEventHandlers = () => {
        document.querySelectorAll('.quick--view').forEach(function (el) {
          el.addEventListener('click', function (event) {
            event.preventDefault(); // Prevent form to be submitted
            // toggle the quick-view modal
            el.parentElement.parentElement.parentElement.querySelector('.ProductItem__quick--view-modal').classList.toggle('quick--view_active');
            // activate body overlay
            document.querySelector('.body-overlay').classList.add('active');
          });
        });
      };

      // quick-view event handler on variant options
      let addVariantOptionEventHandlers = () => {
        document.querySelectorAll('.ProductItem__quick--view-modal .quick--view__radioOptionsContainer div').forEach(function (el) {
          el.addEventListener('click', function (event) {
            let selectedOption = el.parentElement.parentElement.querySelector('select option[value="' + el.querySelector('input').value + '"]');
            selectedOption.selected = true;
            selectedOption.parentElement.dispatchEvent(new Event('change'));
          });
        });
        // select based event handler
        document.querySelectorAll('.ProductItem__quick--view-modal select.color_select').forEach(function (el) {
          el.addEventListener('change', function (event) {
            let radioOptions = el.parentElement.querySelector('.quick--view__radioOptionsContainer');
            let selectedOption = radioOptions.querySelector('input[value="' + el.value + '"]');
            // check if the product can be purchased - compare the data-title attribute of the selected size option with the selected color option
            let selectedColorOption = el.parentElement.querySelector('select.color_select option[value="' + el.value + '"]');
            // ignore if no size select is present
            if (el.parentElement.querySelector('select.size_select') == null) {
              el.parentElement.querySelector('select[name="id"]').value = el.value;
              el.parentElement.querySelector('select[name="id"]').dispatchEvent(new Event('change'));
            } else {
              let selectedSizeOption = el.parentElement.querySelector('select.size_select option[value="' + el.parentElement.querySelector('select.size_select').value + '"]');
              if (selectedColorOption.getAttribute('data-title').split('/')[0] == selectedSizeOption.getAttribute('data-title').split('/')[0]) {
                // update the main select with name="id" to the currently selected option value
                el.parentElement.querySelector('select[name="id"]').value = selectedSizeOption.value;
                el.parentElement.querySelector('select[name="id"]').dispatchEvent(new Event('change'));
                el.parentElement.parentElement.querySelector('.Button').removeAttribute('disabled');
                el.parentElement.parentElement.querySelector('.Button').innerText = 'ADD TO CART';
              } else if (selectedColorOption.getAttribute('data-title').split('/')[1] == selectedSizeOption.getAttribute('data-title').split('/')[1]) { 
              // update the main select with name="id" to the currently selected option value
              el.parentElement.querySelector('select[name="id"]').value = el.value
              el.parentElement.querySelector('select[name="id"]').dispatchEvent(new Event('change'));
              el.parentElement.parentElement.querySelector('.Button').removeAttribute('disabled');
              el.parentElement.parentElement.querySelector('.Button').innerText = 'ADD TO CART';
              } else {
                // if the product cannot be purchased, disable the add to cart button and change the text to 'unavailable'
                el.parentElement.parentElement.querySelector('.Button').setAttribute('disabled', true);
                el.parentElement.parentElement.querySelector('.Button').innerText = 'UNAVAILABLE';
              }
            }

            // get the background image of the selected label and set that to the main image on the right
            el.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector('.quick--view_featured-image img').setAttribute('src',selectedOption.nextElementSibling.style.backgroundImage.split('"')[1]);
          });
        });
        // updating size select (need to check if product can be purchased as not all products will have a size variant)
        document.querySelectorAll('.ProductItem__quick--view-modal select.size_select').forEach(function (el) {
          el.addEventListener('change', function (event) {
            // check if the product can be purchased - compare the data-title attribute of the selected size option with the selected color option
            if (el.parentElement.querySelector('select.color_select') == null) {
              el.parentElement.querySelector('select[name="id"]').value = el.value;
              el.parentElement.querySelector('select[name="id"]').dispatchEvent(new Event('change'));
              el.parentElement.parentElement.querySelector('.Button').removeAttribute('disabled');
              el.parentElement.parentElement.querySelector('.Button').innerText = 'ADD TO CART';
              // change price shown
              let selectedOption = el.parentElement.querySelector('select.size_select option[value="' + el.value + '"]');
              let originalPrice = selectedOption.getAttribute('data-price');
              let taggedDiscountPrice = selectedOption.getAttribute('data-tagged-discount-price');
              let compareAtPrice = selectedOption.getAttribute('data-compare-at-price');
              if (originalPrice != taggedDiscountPrice) {
                // show both the original price and the tagged discount price
                el.parentElement.parentElement.parentElement.parentElement.querySelector('.product--price').innerHTML = '<span class="product--price__tagged">' + taggedDiscountPrice + '</span><span class="product--price__original discounted">' + originalPrice + '</span>';
              } else { 
                // show both the original price
                el.parentElement.parentElement.parentElement.parentElement.querySelector('.product--price').innerHTML = '<span class="product--price__original">' + originalPrice + '</span>';
              }
            } else {
              let selectedColorOption = el.parentElement.querySelector('select.color_select option[value="' + el.parentElement.querySelector('select.color_select').value + '"]');
              let selectedSizeOption = el.parentElement.querySelector('select.size_select option[value="' + el.value + '"]');
              if (selectedColorOption.getAttribute('data-title').split('/')[0] == selectedSizeOption.getAttribute('data-title').split('/')[0]) {
                // update the main select with name="id" to the currently selected option value
                el.parentElement.querySelector('select[name="id"]').value = el.value;
                el.parentElement.querySelector('select[name="id"]').dispatchEvent(new Event('change'));
                el.parentElement.parentElement.querySelector('.Button').removeAttribute('disabled');
                el.parentElement.parentElement.querySelector('.Button').innerText = 'ADD TO CART';
                // change the price of the product
                el.parentElement.parentElement.parentElement.parentElement.querySelector('.product--price').innerText = selectedSizeOption.getAttribute('data-price');
              } else if (selectedColorOption.getAttribute('data-title').split('/')[1] == selectedSizeOption.getAttribute('data-title').split('/')[1]) {
                // update the main select with name="id" to the currently selected option value
                el.parentElement.querySelector('select[name="id"]').value = selectedColorOption.value;
                el.parentElement.querySelector('select[name="id"]').dispatchEvent(new Event('change'));
                el.parentElement.parentElement.querySelector('.Button').removeAttribute('disabled');
                el.parentElement.parentElement.querySelector('.Button').innerText = 'ADD TO CART';
                el.parentElement.parentElement.parentElement.parentElement.querySelector('.product--price').innerText = selectedSizeOption.getAttribute('data-price');
              } else {
                // if the product cannot be purchased, disable the add to cart button and change the text to 'unavailable'
                el.parentElement.parentElement.querySelector('.Button').setAttribute('disabled', true);
                el.parentElement.parentElement.querySelector('.Button').innerText = 'UNAVAILABLE';
              }
            }
            });
          
        });
      };

      // update all notify me buttons innerHTML to 'Notify Me'
      setTimeout(() => {
        document.querySelectorAll('.osf--oos button').forEach(function (el) {
          el.innerHTML = 'Notify Me';
        });
        console.log('updated notify me buttons');
      }, 1200);


      document.querySelectorAll('.ProductItem__quick--view-modal .quick--view__select-main--ID').forEach(function (el) {
        el.addEventListener('change', function (event) {
          // get the data availability attribute of the selected option
          let selectedOption = el.querySelector('option[value="' + el.value + '"]');
          if (selectedOption.getAttribute('data-availability') == 'true') {
            // hide the notify me button
            el.parentElement.parentElement.querySelector('.osf--oos').classList.add('hidden');
            el.parentElement.parentElement.querySelector('.osf--oos').classList.remove('active');
            // show the add to cart button
            el.parentElement.parentElement.querySelector('.atc_prod').classList.remove('hidden');
            el.parentElement.parentElement.querySelector('.atc_prod').classList.add('active');
        } else {
          // show the notify me button
          el.parentElement.parentElement.querySelector('.osf--oos').classList.remove('hidden');
          el.parentElement.parentElement.querySelector('.osf--oos').classList.add('active');
          // hide the add to cart button
          el.parentElement.parentElement.querySelector('.atc_prod').classList.add('hidden');
          el.parentElement.parentElement.querySelector('.atc_prod').classList.remove('active');
        }
      });
      });

      // change the notify me button's selected product option based on the selected ID option
      document.querySelectorAll('.ProductItem__quick--view-modal .osf--oos').forEach(function (el) {
        el.addEventListener('click', function (event) {
          // get the currently selected ID option in this modal
          let selectedIDOption = el.parentElement.parentElement.querySelector('select.quick--view__select-main--ID').value;
          // set the selected option for the notify me button - the select is created via the app so we have to delay slightly
          setTimeout(() => {
            document.querySelector('select.osf_select').value = selectedIDOption;
            document.querySelector('select.osf_select').dispatchEvent(new Event('change'));
          }, 100);
        });
      });

            // close all quick-view modals
            let closeAllQuickViewModals = () => {
              document.querySelectorAll('.ProductItem__quick--view-modal').forEach(function (el) {
                el.classList.remove('quick--view_active');
                document.querySelector('.body-overlay').classList.remove('active');
              });
            };

      // add body overlay click event handlers
      let addBodyOverlayEventHandlers = () => {
        document.querySelector('.body-overlay').addEventListener('click', (e) => {
          // toggle the body-overlay active class
          closeAllQuickViewModals();
        });
      };

      // add modal close click event handlers
      let addCloseModalEventHandlers = () => {
        document.querySelectorAll('.close--modal').forEach((el) => { 
          el.addEventListener('click', (e) => {
            closeAllQuickViewModals();
        })
        });
      };

      // add to cart event handler on collection items
      let addToCartEventHandlers = () => {
        document.querySelectorAll('.atc_prod').forEach(function (el) {
          el.addEventListener('click', function (event) {
            event.preventDefault(); // Prevent form to be submitted

            el.setAttribute("disabled", "disabled");
            document.dispatchEvent(
              new CustomEvent("theme:loading:start")
            ); // Then we add the product in Ajax

            var formElement = el.closest('form')

            fetch("".concat(window.routes.cartAddUrl, ".js"), {
              body: JSON.stringify({
                'items': [{
                  'id': formElement.querySelector('[name="id"]').value,
                  'quantity': formElement.querySelector('[name="quantity"]').value
                }]
              }),
              credentials: "same-origin",
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest", // This is needed as currently there is a bug in Shopify that assumes this header
              },
            }).then(function (response) {
              document.dispatchEvent(
                new CustomEvent("theme:loading:end")
              );
              var quantityElement =
                formElement.querySelector('[name="quantity"]');

              if (response.ok) {
                el.removeAttribute("disabled"); // We simply trigger an event so the mini-cart can re-render

                document.dispatchEvent(
                  new CustomEvent("product:added", {
                    bubbles: true,
                    detail: {
                      variant: formElement.querySelector('[name="id"]').value,
                      quantity: quantityElement
                        ? parseInt(quantityElement.value)
                        : 1,
                    },
                  })
                );
                closeAllQuickViewModals();
              } else {
                response.json().then(function (content) {
                  var errorMessageElement =
                    document.createElement("span");
                  errorMessageElement.className =
                    "ProductForm__Error Alert Alert--error";
                  if (content['description'] == 'Required parameter missing or invalid: id') {
                    errorMessageElement.innerHTML =
                      "Please select a variant before adding to cart";
                  } else {
                    // currently selected variant
                    let productSelectVariant = el.parentElement.parentElement.querySelector('[name="id"]').value;
                    let productURL = el.parentElement.parentElement.parentElement.querySelector('.quick--view__product-details').getAttribute('href');
                    errorMessageElement.innerHTML =
                     `${content["description"]} <a href="${productURL}?variant=${productSelectVariant}--auto_notify-${productSelectVariant}">Click HERE to be notified when it's back in stock.</a>`;
                  }
                  el.removeAttribute("disabled");
                  if (el.parentElement.parentElement.querySelector('.ProductForm__Error') != null) {
                    document.querySelector('.ProductForm__Error').remove();
                  }
                  el.insertAdjacentElement(
                    "afterend",
                    errorMessageElement
                  );
                  setTimeout(function () {
                    errorMessageElement.remove();
                  }, 7000);
                });
              }
            });
          });
        });
      }

      // quick view quantity update event handler
      let addQuickViewQuantityUpdateEventHandlers = () => {
        document.querySelectorAll('.QuantitySelector__Button').forEach(function (el) {
          el.addEventListener('click', function (event) {
            // update the quantity in the form based on data-action
            if (el.parentElement.querySelector('input[name="quantity"]').value == 1 && el.dataset.action == 'decrease-quantity') {
              return;
            }
            if (el.dataset.action == 'decrease-quantity') {
              el.parentElement.querySelector('input[name="quantity"]').value = parseInt(el.parentElement.querySelector('input[name="quantity"]').value) - 1;
            } else {
              el.parentElement.querySelector('input[name="quantity"]').value = parseInt(el.parentElement.querySelector('input[name="quantity"]').value) + 1;
            }
          });
        });
      };

      // add quick view event listeners - Execute after render
      addQuickViewEventHandlers();
      // add add to cart event listeners - Execute after render
      addToCartEventHandlers();
      // add body overlay event listeners - Execute after render
      addBodyOverlayEventHandlers();
      // add close modal event listeners - Execute after render
      addCloseModalEventHandlers();
      // add variant option event listeners - Execute after render
      addVariantOptionEventHandlers();
      // add quick view quantity update event listeners - Execute after render
      addQuickViewQuantityUpdateEventHandlers();



      // END EVENT HANDLERS //



      /**
       *  Call theme function 
       *  1. Add var bcPrestigeSections; var bcPrestigeSectionContainer; to assets/theme.min.js
       *  2. In assets/theme.min.js, find var YYY=new XXX.SectionContainer; For example: var e=new o.SectionContainer;
       *  3. Replace var e=new o.SectionContainer; by var e=new o.SectionContainer; var YYY = new XXX.SectionContainer;  bcPrestigeSections = YYY; bcPrestigeSectionContainer = XXX;

      if(typeof bcPrestigeSectionContainer != 'undefined' && typeof bcPrestigeSections != 'undefined'){
      bcPrestigeSections.register("collection", bcPrestigeSectionContainer.CollectionSection);
      bcPrestigeSections.register("search", bcPrestigeSectionContainer.SearchSection);
      }  
      */

      // Fix image not load on Instagram browser - initialize swatch image
      jQ(".ProductItem__Info .ProductItem__ColorSwatchList .ProductItem__ColorSwatchItem label.ColorSwatch").click(function () {
        jQ(this).parent().parent().find('label.ColorSwatch').removeClass('active');
        jQ(this).addClass('active');
        var parent = jQ(this).parent();
        var productImage = jQ(this).parent().parent().parent().parent().find('a.ProductItem__ImageWrapper');
        var variantInfo = parent.find('input.ColorSwatch__Radio');
        productImage.find('.AspectRatio .bc-sf-product-swatch-img').remove();
        productImage.find('.AspectRatio').prepend('<img class="bc-sf-product-swatch-img" src="' + variantInfo.data('image-url') + '" />');
        productImage.find('img.ProductItem__Image').hide();
        productImage.attr('href', variantInfo.data('variant-url'));
        var variantPrice = '';
        if (variantInfo.data('variant-compare-at-price') > variantInfo.data('variant-price')) {
          variantPrice += '<span class="ProductItem__Price Price Price--highlight Text--subdued" data-money-convertible="">' + Utils.formatMoney(variantInfo.data('variant-price')) + '</span>'
          variantPrice += '<span class="ProductItem__Price Price Price--compareAt Text--subdued" data-money-convertible="">' + Utils.formatMoney(variantInfo.data('variant-compare-at-price')) + '</span>';
        } else {
          variantPrice += '<span class="ProductItem__Price Price Text--subdued" data-money-convertible>' + Utils.formatMoney(variantInfo.data('variant-price')) + '</span>';
        }
        jQ(this).closest('.ProductItem__Wrapper').find('.ProductItem__PriceList').html(variantPrice);
      })

      //Change view layout
      var desktopView = jQ('.CollectionToolbar__LayoutSwitch.hidden-phone').find('.is-active').data('count');
      if (desktopView && desktopView != parseInt(boostPFSConfig.custom.desktop_row)) {
        jQ(Selector.products + ' .Grid__Cell').removeClass('1/' + boostPFSConfig.custom.tablet_row + '--tablet-and-up 1/' + boostPFSConfig.custom.desktop_row + '--' + buildClass());
        jQ(Selector.products + ' .Grid__Cell').addClass('1/' + desktopView + '--tablet-and-up 1/' + desktopView + '--' + buildClass());
      }
      var mobileView = jQ('.CollectionToolbar__LayoutSwitch.hidden-tablet-and-up').find('.is-active').data('count');
      if (mobileView && mobileView != parseInt(boostPFSConfig.custom.mobile_row)) {
        jQ(Selector.products + ' .Grid__Cell').removeClass('1/' + boostPFSConfig.custom.mobile_row + '--phone');
        jQ(Selector.products + ' .Grid__Cell').addClass('1/' + mobileView + '--phone');
      }
    };

    // Build additional elements
    FilterResult.prototype.afterRender = function (data, eventType) {
      if (!data) data = this.data;
      if (!eventType) eventType = this.eventType;
    };

    // Build Default layout
    Filter.prototype.errorFilterCallback = function () { var isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, isSafari = /Safari/.test(navigator.userAgent), isBackButton = window.performance && window.performance.navigation && 2 == window.performance.navigation.type; if (!(isiOS && isSafari && isBackButton)) { var self = this, url = window.location.href.split("?")[0], searchQuery = self.isSearchPage() && self.queryParams.hasOwnProperty("q") ? "&q=" + self.queryParams.q : ""; window.location.replace(url + "?view=bc-original" + searchQuery) } };
  })();
}
